export const gMachineAppViews = Object.freeze({
  machineParameters : 'machineParameters',
  globalAsset       : 'globalAsset',
  configuration     : 'configuration',
  application       : 'application'
});

export const gMachineAppExplanationText = "MachineApps allow you to easily configure, program and operate your Vention solution. MachineApps guide you through the creation of an application to get your Vention machine up and running in minutes, with the option to add custom MachineLogic instructions at key moments to tailor it exactly to your needs.";
